// Aplica favicon, título e fonte dinamicamente, a partir da configuração de
// marca do tenant (configuracoes_site, servido em /api/site/configuracoes).
// Precisa rodar cedo e em toda tela pública (login, app), não só na tela de
// personalização do admin — senão um visitante nunca autenticado continua
// vendo o favicon/título/fonte padrão do build compartilhado.

export function aplicarFavicon(emoji, url) {
  const href = url && url.trim()
    ? url.trim()
    : `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="90">${emoji || '📅'}</text></svg>`)}`;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

export function aplicarTitulo(titulo) {
  if (titulo && titulo.trim()) document.title = titulo.trim();
}

// Catálogo de fontes disponíveis pra personalização — todas já carregadas de
// uma vez no <link> do Google Fonts em public/index.html, então trocar aqui
// é instantâneo (sem round-trip extra). "id" é o que fica salvo na config;
// "pilha" é o valor CSS completo (com fallbacks) aplicado em --font-family.
export const FONTES_DISPONIVEIS = [
  { id: 'Inter',           label: 'Inter (padrão)', pilha: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Poppins',         label: 'Poppins',        pilha: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Roboto',          label: 'Roboto',         pilha: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Montserrat',      label: 'Montserrat',     pilha: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Nunito',          label: 'Nunito',         pilha: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Lato',            label: 'Lato',           pilha: "'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Quicksand',       label: 'Quicksand',      pilha: "'Quicksand', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
  { id: 'Playfair Display',label: 'Playfair Display (elegante)', pilha: "'Playfair Display', Georgia, 'Times New Roman', serif" },
];
const FONTE_PADRAO = FONTES_DISPONIVEIS[0];

export function pilhaDaFonte(id) {
  return (FONTES_DISPONIVEIS.find(f => f.id === id) || FONTE_PADRAO).pilha;
}

export function aplicarFonte(id) {
  document.documentElement.style.setProperty('--font-family', pilhaDaFonte(id));
}

// Converte #rrggbb em "r, g, b" — usado pra permitir rgba(var(--color-primary-rgb), alpha)
// em sombras/overlays que precisam de transparência (var() sozinho não dá pra combinar
// com rgba() sem o CSS já receber os componentes separados).
export function hexParaRgb(hex) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i.exec(hex || '');
  if (!m) return null;
  return `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`;
}

export function aplicarBrandingBasico(cfg) {
  if (!cfg) return;
  aplicarFavicon(cfg.favicon?.emoji || cfg.cabecalho?.icone, cfg.favicon?.url);
  aplicarTitulo(cfg.cabecalho?.titulo);
  aplicarFonte(cfg.tipografia?.fonte);
}
